<script lang="ts" setup=""></script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="100%" height="100%">
        <!--! Font Awesome Pro 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
        <path d="M336 464V160H224V48H48V464H336zM48 0H256L384 128V464v48H336 48 0V464 48 0H48z" />
    </svg>
</template>
